import { configureStore } from '@reduxjs/toolkit';

import signupSlice from './slices/signupSlice';
import shopSlice from './slices/shopSlice';
import staffSlice from './slices/staffSlice';
import orderSlice from './slices/orderSlice';

export const store = configureStore({
  reducer: {
    signup: signupSlice,
    shops: shopSlice,
    staff: staffSlice,
    order: orderSlice,
  },
});
